import { useEffect, useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { http } from "./api";

export default function Signup({ onSignup, onCancel }) {
  const [plans, setPlans] = useState([]);
  const [plan, setPlan] = useState("trial");
  const [form, setForm] = useState({ org_name: "", slug: "", admin_name: "", admin_email: "", admin_password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { http.get("/plans").then((r) => setPlans(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const r = await http.post("/tenants/signup", { ...form, plan });
      onSignup(r.data.user);
    } catch (err) {
      setError(err.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

  return (
    <div className="signup-page">
      <header className="signup-topbar">
        <div className="form-brand"><div className="mark">84</div><span>Ward 7 CRM · Jonogoner Swarthe Ward 7</span></div>
        <button className="link" data-testid="signup-back-button" onClick={onCancel}>← Back to sign in</button>
      </header>
      <main className="signup-main">
        <section className="signup-hero">
          <p className="eyebrow">START A NEW WORKSPACE</p>
          <h1>Launch your CRM in <i>60 seconds.</i></h1>
          <p className="sub">One tenant. One team. Own branding, own booth data, own domain — no back-and-forth setup.</p>
          <ul className="signup-features">
            <li><Check size={14} /> Instant provisioning · your data isolated from day one</li>
            <li><Check size={14} /> White-label — logo, colours, tagline & login copy</li>
            <li><Check size={14} /> All 16 modules from day one, upgrade any time</li>
            <li><Check size={14} /> Custom subdomain <code>&lt;slug&gt;.nabadwip.crm</code> — custom domain on Growth+</li>
          </ul>
        </section>

        <section className="signup-panel">
          <h2>1 · Pick a plan</h2>
          <div className="plans">
            {plans.map((p) => (
              <button key={p.id} className={`plan-card ${plan === p.id ? "active" : ""}`} data-testid={`plan-${p.id}`} onClick={() => setPlan(p.id)} type="button">
                <div className="plan-head"><b>{p.name}</b>{p.id === "growth" && <span className="chip green">Popular</span>}</div>
                <div className="plan-price">{p.price === 0 ? "Free" : inr(p.price)}<small>{p.price === 0 ? ` · ${p.days}-day trial` : "/mo"}</small></div>
                <ul>
                  <li>{p.limits.contacts.toLocaleString("en-IN")} contacts</li>
                  <li>{p.limits.broadcasts_per_month} broadcasts / month</li>
                  <li>{p.limits.seats} team seats</li>
                  <li>{p.limits.white_label ? "✓" : "—"} White-label branding</li>
                  <li>{p.limits.custom_domain ? "✓" : "—"} Custom domain</li>
                </ul>
              </button>
            ))}
          </div>

          <h2>2 · Your workspace</h2>
          <form className="signup-form" onSubmit={submit}>
            <label>Organisation name<input data-testid="signup-org" value={form.org_name} onChange={(e) => setForm({ ...form, org_name: e.target.value, slug: e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 32) })} required /></label>
            <label>Workspace slug<input data-testid="signup-slug" value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "") })} required />
              <small>Your URL: <code>{form.slug || "your-slug"}.nabadwip.crm</code></small></label>
            <div className="form-grid">
              <label>Your name<input data-testid="signup-name" value={form.admin_name} onChange={(e) => setForm({ ...form, admin_name: e.target.value })} required /></label>
              <label>Work email<input data-testid="signup-email" type="email" value={form.admin_email} onChange={(e) => setForm({ ...form, admin_email: e.target.value })} required /></label>
            </div>
            <label>Password<input data-testid="signup-password" type="password" minLength={8} value={form.admin_password} onChange={(e) => setForm({ ...form, admin_password: e.target.value })} required /></label>
            {error && <div className="login-error" data-testid="signup-error">{error}</div>}
            <button className="primary login-submit" data-testid="signup-submit" disabled={busy}>{busy ? "Launching…" : "Launch workspace"} <ArrowUpRight size={16} /></button>
            <small className="login-foot">By continuing you accept our fair-use policy. Trial requires no card.</small>
          </form>
        </section>
      </main>
    </div>
  );
}
